import { Module } from 'vuex'
import { RootState } from '@/store'
import mutations from '@/store/filter/mutations'
import { path } from '@/store/filter/types'
import { mutation } from '@/utils/mutation'
import state, { IFilterState } from '@/store/filter/state'

export * from '@/store/filter/state'

export const store: Module<IFilterState, RootState> = {
  state,
  mutations: mutation(mutations, path)
}
